import { existingHeaders } from "./utils";

import { getUrl } from "utils/urls.js";

const forgotPasswordFormUrl = "/password/forgotten-password";
const forgottenPasswordVerifyTokenUrl = "/password/token/verification";
const resetPasswordUrl = "/password/reset";
const myIdSetPasswordUrl = getUrl("myIdSetPassword");

export const passwordService = {
  forgotPassword,
  checkToken,
  resetPassword,
  myIdSetPassword,
};

function forgotPassword({ email, ioBlackbox, recaptchaToken }) {
  const requestOptions = {
    method: "POST",
    headers: existingHeaders,
    body: JSON.stringify({ email, ioBlackbox, recaptchaToken }),
  };
  return fetch(forgotPasswordFormUrl, requestOptions);
}

function checkToken(token) {
  const requestOptions = {
    method: "POST",
    headers: existingHeaders,
    credentials: "same-origin",
    body: JSON.stringify({ token: token }),
  };
  return fetch(forgottenPasswordVerifyTokenUrl, requestOptions);
}

function resetPassword(token, new_password) {
  const requestOptions = {
    method: "PUT",
    headers: {
      ...existingHeaders,
    },
    credentials: "same-origin",
    body: JSON.stringify({ token, new_password }),
  };
  return fetch(resetPasswordUrl, requestOptions);
}

function myIdSetPassword(new_password) {
  const requestOptions = {
    method: "POST",
    headers: {
      ...existingHeaders,
    },
    credentials: "same-origin",
    body: JSON.stringify({ new_password }),
  };
  return fetch(myIdSetPasswordUrl, requestOptions);
}
